import type { QueryStoreProps } from "./List.js";
import type { DataKey, Database } from "shelving";
import { PaginateButton } from "./PaginateButton.js";

/** Output a paginated set of results as a table. */
export function Table<T extends Database, K extends DataKey<T>>({
	mods = "", //
	before = null,
	after = null,
	store,
	empty = `No ${store.collection}s`,
	detect,
	more,
	mapper,
}: QueryStoreProps<T, K>): React.ReactElement | null {
	const { value, hasMore } = store;
	if (!value.length && empty === null) return null;
	return (
		<table className={mods}>
			<tbody>
				{before}
				{value.length ? (
					value.map(mapper)
				) : (
					<tr>
						<td colSpan={999} className="color-quiet size-small">
							{empty}
						</td>
					</tr>
				)}
				{after}
				{more !== null && value.length && hasMore ? (
					<tr>
						<td colSpan={999} className="pad-none">
							<PaginateButton store={store} detect={detect} mods="size-small button-quiet">
								{more}
							</PaginateButton>
						</td>
					</tr>
				) : null}
			</tbody>
		</table>
	);
}
